import { startAnalyticsVisit } from '~/utils/time_tracked_analytics';

if (window.analytics) {
  startAnalyticsVisit();

  const registerStatsigMiddleware = () => {
    try {
      if (analytics._statsigMiddlewareRegistered) {
        return;
      }

      if (typeof analytics.addSourceMiddleware !== 'function') {
        analytics._statsigRegisterAttempts = (analytics._statsigRegisterAttempts || 0) + 1;

        if (analytics._statsigRegisterAttempts < 10) {
          setTimeout(registerStatsigMiddleware, 200);
        }

        return;
      }

      analytics.addSourceMiddleware(({ payload, next }) => {
        try {
          if (payload.type() === 'track') {
            const properties = payload.obj.properties || {};

            // Build statsigCustom array with all primitive properties
            // Format: [key1, val1, key2, val2, ...]
            const statsigCustom = Object.entries(properties).reduce((acc, [k, v]) => {
              if (v === null || v === undefined) {
                return acc;
              }

              if (Array.isArray(v) || (typeof v === 'object' && v !== null)) {
                return acc;
              }

              acc.push(String(k), String(v));

              return acc;
            }, []);

            if (statsigCustom.length > 0) {
              payload.obj.properties = {
                ...properties,
                statsigCustom,
              };
            }
          }
        } catch (_err) {
          // Ignore statsig processing errors to avoid breaking the app.
        }

        next(payload);
      });

      analytics._statsigMiddlewareRegistered = true;
    } catch (_err) {
      // Ignore errors registering middleware synchronously
    }
  };

  // Try to register immediately (for early events). Also register again inside
  // `analytics.ready` as a fallback if the analytics client wasn't fully ready.
  registerStatsigMiddleware();

  window.analytics.ready(() => {
    registerStatsigMiddleware();
  });
}
